<script>

    /**
     * Campo individual dentro de un InfoCard.
     * Se comporta como una columna Bulma dentro del grid is-multiline.
     *
     * Props:
     *   label   — texto de la etiqueta
     *   icon    — clase Font Awesome, ej. "fas fa-user" (opcional)
     *   size    — ancho de la columna: "half" | "full" | "one-quarter" | "three-quarters"
     *   value   — valor en texto plano (alternativa al slot default)
     *   bold    — aplica has-text-weight-medium al valor
     *   color   — color Bulma del valor: "success" | "danger" | "warning" | "grey" | "grey-dark" …
     */

    export let label = ""
    export let icon = ""
    export let size = "half"
    export let value = ""
    export let bold = false
    export let color = ""

    const sizeClasses = {
        half: 'is-full-mobile is-half-tablet',
        full: 'is-full',
        'one-quarter': 'is-full-mobile is-one-quarter-tablet',
        'three-quarters': 'is-full-mobile is-three-quarters-tablet',
    }

    $: columnSizeClass = sizeClasses[size] || sizeClasses.half

</script>

<div class="column {columnSizeClass} pb-3 info-field">
    <p class="heading has-text-grey mb-1">
        {#if icon}
            <span class="icon is-small mr-1"><i class="{icon}"></i></span>
        {/if}
        { label }
    </p>
    <div class="info-field__content">
        <slot>
            <p
                class="is-size-6 info-field__value"
                class:has-text-weight-medium={bold}
                class:has-text-success={color === 'success'}
                class:has-text-danger={color === 'danger'}
                class:has-text-warning={color === 'warning'}
                class:has-text-grey={color === 'grey'}
                class:has-text-grey-dark={color === 'grey-dark'}
            >{ value }</p>
        </slot>
    </div>
</div>

<style>

    .info-field {
        min-width: 0;
    }

    .info-field__content {
        min-width: 0;
        overflow-wrap: anywhere;
        word-break: break-word;
    }

</style>
